import * as Yup from "yup";

export interface SettingsDetailsFormValues {
    showMe: string[];
  }

  export const settingsDetailsValidationSchema = Yup.object({
    showMe: Yup.array()
      .of(Yup.string())
      .min(1, "Select at least one option")
      .required("Show Me is required"),
  });
  